import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import Logo from './Logo';

const Header = ({ setIsAuditModalOpen }) => {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();

    const scrollToSection = (id) => {
        if (location.pathname !== '/') {
            navigate('/#' + id);
            return;
        }
        const element = document.getElementById(id);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
            setIsMobileMenuOpen(false);
        }
    };

    return (
        <header className="dark-header">
            <div className="header-content">
                <div
                    className="logo-section"
                    onClick={() => navigate('/')}
                    style={{ cursor: 'pointer' }}
                    role="banner"
                    aria-label="Adjactive Home"
                >
                    <Logo size={32} />
                    <span className="logo-text">ADJACTIVE</span>
                </div>

                <nav className="dark-nav desktop-nav">
                    <button onClick={() => scrollToSection('framework')} className="dark-nav-link">Framework</button>
                    <button onClick={() => scrollToSection('research')} className="dark-nav-link">Research</button>
                    <a href="/blog" className="dark-nav-link">Blog</a>
                    <a href="mailto:tech@adjactive.com" className="dark-nav-link">Contact</a>
                    <button 
                      onClick={() => window.location.href = 'https://beta.adjactive.com'} className="btn-primary btn-small">
                        Join Waiting list
                    </button>
                </nav>

                <button
                    className="mobile-menu-btn"
                    onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                    aria-label={isMobileMenuOpen ? "Close menu" : "Open menu"}
                    aria-expanded={isMobileMenuOpen}
                >
                    {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
                </button>
            </div>

            {isMobileMenuOpen && (
                <div className="mobile-menu">
                    <button onClick={() => scrollToSection('framework')} className="mobile-nav-link">Framework</button>
                    <button onClick={() => scrollToSection('research')} className="mobile-nav-link">Research</button>
                    <a href="/blog" className="mobile-nav-link">Blog</a>
                    <a href="mailto:tech@adjactive.com" className="mobile-nav-link">Contact</a>
                    <button onClick={() => { setIsAuditModalOpen(true); setIsMobileMenuOpen(false); }} className="btn-primary btn-full">
                        Request AI Audit
                    </button>
                </div>
            )}
        </header>
    );
};

export default Header;
